import { ArticleStatus } from '@bp/shared/domains/articles';

export class NewsStatus extends ArticleStatus {
}
